import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@shared/shared.module';
import { ButtonSize, ButtonTypes } from '@shared/modules/ui/components/button/button.component';
import { FormsV2Module } from '@shared/modules/forms-v2/forms-v2.module';

interface DocumentFileNameModalData {
  fileName: string;
}

@Component({
  selector: 'document-file-name-modal',
  standalone: true,
  imports: [ReactiveFormsModule, TranslateModule, SharedModule, FormsV2Module],
  templateUrl: './document-file-name-modal.component.html',
  styleUrls: ['./document-file-name-modal.component.scss'],
  styles: [
    `
      .new-modal {
        min-width: initial;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentFileNameModalComponent {
  protected readonly ButtonSize = ButtonSize;
  protected readonly ButtonTypes = ButtonTypes;
  protected readonly fileName: FormControl<string>;

  constructor(
    private readonly dialogRef: MatDialogRef<DocumentFileNameModalComponent, string>,
    @Inject(MAT_DIALOG_DATA) protected readonly data: DocumentFileNameModalData
  ) {
    this.fileName = new FormControl(this.data.fileName || '', {
      nonNullable: true,
      validators: [Validators.required]
    });
    this.dialogRef.disableClose = true;
    this.dialogRef.backdropClick().subscribe(() => this.close());
  }

  protected close(): void {
    this.dialogRef.close();
  }

  protected save(): void {
    this.fileName.markAsTouched();
    if (this.fileName.invalid) return;

    this.dialogRef.close(this.fileName.getRawValue().trim());
  }
}
